module.exports = __webpack_public_path__ + "img/deer.5f36b8d6.jpg";